// Labels y tooltips compartidos para la verificación de entregabilidad de
// emails (BounceBan). Resultados posibles del backend: deliverable, risky,
// undeliverable, unknown.

export const VERIFICATION_RESULT_LABELS = {
  deliverable: "Entregable",
  risky: "Riesgoso",
  undeliverable: "No entregable",
  unknown: "Desconocido",
};

export function getVerificationResultLabel(result) {
  return VERIFICATION_RESULT_LABELS[result] || result || "Pendiente";
}

function formatVerifiedAtDate(dateString) {
  if (!dateString) return null;
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString("es-AR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function getVerifiedStatusTooltip(contact) {
  if (!contact?.is_verified) {
    return "Email sin validación vigente.";
  }
  const verifiedAtText = formatVerifiedAtDate(contact.verified_at);
  return verifiedAtText
    ? `Email validado como entregable el ${verifiedAtText}. La validación vence a los 30 días.`
    : "Email validado como entregable. La validación vence a los 30 días.";
}
